import { MDBIcon, MDBInput, MDBDataTable } from 'mdbreact';
import React, { Component } from 'react';
import FileUploader from './ProductosDetalles/FileUploader';
import Swal from 'sweetalert2';
import { CargueImagenes, ProductosDetallesGET_, ProductosDetalles_, ProductosSimula_ } from '../../../services/WebAPI_Utrahuilca';
import { URLImgFront } from '../../../config/URLDB';

const validate = values => {
    const errors = {}
    if (values.idprodutra === 'DEFAULT') {
        errors.idprodutra = 'campo obligatorio'
    }
    if (!values.txtprodvtadet1) {
        errors.txtprodvtadet1 = 'campo obligatorio'
    }
    if (!values.txtprodvtadet2) {
        errors.txtprodvtadet2 = 'campo obligatorio'
    }
    if (!values.txtprodvtadet3) {
        errors.txtprodvtadet3 = 'campo obligatorio'
    }
   
    return errors;
};

class ProductosDetalles extends Component {
    //RQTO. CDAT Y AHORRO DIGITAL, REAJUSTE YC
    uploader = React.createRef();
    uploader1 = React.createRef();
    uploader2 = React.createRef();
    uploader3 = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            estadoNuevo: false,
            errors: {},
            infoProductos: [],
            stateView: false,
            stateActive: false,
            manejaItemState: false,
            manejaBeneficiosState: false,
            manejaRequisitosState: false,
            idprodutra: 'DEFAULT',
            rutaproddet: '',

            descitemprod: '',
            descbenefprod: '',
            descrequisprod: '',

            Items: [],
            Beneficios: [],
            Requisitos: [],
            ItemsImage: [],
            BeneficiosImage: [],
            RequisitosImage: [],

            stateManejaRutaBen: false,
            stateManejaRutaReq: false,
            stateEdit: true,

            estadoCambio: true,
            estadoCambio1: true,
            estadoSinResultados: true,
            infoProductosDetalles: [],
            stateImg: false,
            dataArray: [],
            estadoEditar: false,
            statevistaEstado: 'DEFAULT',
            editmanejaItems: 1,
            editmanejaben: 1,
            editmanejareq: 1,
            editidprodutra: null,
            informacionSeleccionada: null
        };
    }

    componentDidMount() {
        this.cargarSelect();
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const data = {
            tran: 4,
            idprodvtadet: 0,
            idprodutra: 0,
            txtprodvtdet1: 'NA',
            txtprodvtdet2: 'NA',
            txtprodvtdet3: 'NA',
            rutaimgdetalle: 'NA',
            idtipovista: 0,
            infoadicional: 'NA',
            estado: 1,
            usucrea: 'NA'
        }
        ProductosDetallesGET_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        if (response.data[0].message === "004404") {
                            this.setState({
                                stateImg: false
                            })
                        } else {
                            this.setState({
                                infoProductosDetalles: response.data,
                                estadoSinResultados: false,
                                stateImg: true
                            });
                        }
                    } else {
                        this.setState({
                            stateImg: false
                        })
                    }
                } else {
                    console.log(response);
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    cargarSelect = (paramtran, paramidprodutra) => {
        const data = {
            tran: paramtran,
            idprodutra: paramidprodutra,
            nombprodutra: 'NA',
            descprodutra: 'NA',
            rutaimgprod: 'NA',
            rutavistaprod: 'NA',
            prolinea: 0,
            idtipoprod: 0,
            idtipopers: 0,
            estado: 1,
            usucrea: 'NA',
            idtipocuenta: 0,
            idclasificprod: 0,
            prodnuevo: 0,
            fecnuevohasta: '1900-01-01',
            rutaproddet: 'NA'
        }
        ProductosSimula_(data).then(response => {
            try {
                if (response.data.length >= 1) {
                    this.setState({
                        infoProductos: response.data,
                    })
                }
            } catch (error) {
                this.setState({
                    infoProductos: [],
                })
                Swal.fire({
                    icon: 'error',
                    text: 'Ocurrio un error al consumir el servicio, comuniquese con sistemas!'
                })
            }
        });
    }

    ManejaItems = (e) => {
        if (e.target.value === "0") {
            this.setState({
                manejaitems: 0,
                editmanejaItems: 0,
                manejaItemState: false
            })
        } else if (e.target.value === "1") {
            this.setState({
                manejaitems: 1,
                editmanejaItems: 1,
                manejaItemState: true
            })
        }
    }

    ManejaBeneficios = (e) => {
        if (e.target.value === "0") {
            this.setState({
                manejabeneficios: 0,
                editmanejaben: 0,
                manejaBeneficiosState: false
            })
        } else if (e.target.value === "1") {
            this.setState({
                manejabeneficios: 1,
                editmanejaben: 1,
                manejaBeneficiosState: true
            })
        }
    }

    ManejaRequisitos = (e) => {
        if (e.target.value === "0") {
            this.setState({
                manejarequisitos: 0,
                editmanejareq: 0,
                manejaRequisitosState: false
            })
        } else if (e.target.value === "1") {
            this.setState({
                manejarequisitos: 1,
                editmanejareq: 1,
                manejaRequisitosState: true
            })
        }
    }

    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    ManejaRutaBene = (e) => {
        if (e.target.value === "0") {
            this.setState({
                manejarutaimgBen: 0,
                stateManejaRutaBen: false
            })
        } else if (e.target.value === "1") {
            this.setState({
                manejarutaimgBen: 1,
                stateManejaRutaBen: true
            })
        }
    }

    ManejaRutaReq = (e) => {
        if (e.target.value === "0") {
            this.setState({
                manejarutaimgReq: 0,
                stateManejaRutaReq: false
            })
        } else if (e.target.value === "1") {
            this.setState({
                manejarutaimgReq: 1,
                stateManejaRutaReq: true
            })
        }
    }

    //////////////////////////////////////

    cambio = (name, file) => {
        this.setState({
            estadoCambio1: true
        });
    }

    cambioAct = (name, file) => {
        this.setState({
            estadoCambio: false
        });
    }

    cargarImagen = () => {
        var formData = new FormData();
        if (undefined === this.uploader.current) return;
        
        formData.append("file", this.uploader.current.getFileObject());
        formData.append("rutaImagen", '/Productos/Producto Detalles/' + this.uploader.current.getFileName());
        if (this.state.ItemsImage.length > 0) {
            for (let i = 0; i < this.state.ItemsImage.length; i++) {
                if (this.state.ItemsImage[i].rutaiconitem !== "NA") {
                    formData.append("file", this.state.ItemsImage[i].imagen);
                    formData.append("rutaImagen", this.state.ItemsImage[i].rutaiconitem);
                }
            }
        }
        if (this.state.BeneficiosImage.length > 0) {
            for (let i = 0; i < this.state.BeneficiosImage.length; i++) {
                if (this.state.BeneficiosImage[i].rutaimgbenefprod !== "NA") {
                    formData.append("file", this.state.BeneficiosImage[i].imagen);
                    formData.append("rutaImagen", this.state.BeneficiosImage[i].rutaimgbenefprod);
                }
            }
        }
        if (this.state.RequisitosImage.length > 0) {
            for (let i = 0; i < this.state.RequisitosImage.length; i++) {
                if (this.state.RequisitosImage[i].rutaimgrequistprod !== "NA") {
                    formData.append("file", this.state.RequisitosImage[i].imagen);
                    formData.append("rutaImagen", this.state.RequisitosImage[i].rutaimgrequistprod);
                }
            }
        }

        CargueImagenes(formData).then(response => {
            if (response) {
                this.cargarInformacion();
                return;
            }
        });
    }

    limpiarFormulario = () => {
        this.setState({
            estadoCambio1: true,
            rutafotoagenc: '',
            txtprodvtadet1: '',
            txtprodvtadet2: '',
            txtprodvtadet3: '',
            infoadicional: '',
            nombreboton: 'Crear',
            idprodutra: 'DEFAULT',
            infoProductos: [],
            informacionSeleccionada: null,
            errors: {}
        });
    }

    handleNew = (datos) => {
        this.setState({ estadoNuevo: !this.state.estadoNuevo, });
        this.limpiarFormulario();

        if (datos === null) {
            this.setState({
                estadoCambio1: true
            });

            this.cargarSelect(11, 0);
        }
        else {
            this.cargarSelect(14, datos.idprodutra);
            this.setState({
                estadoCambio1: false,
                informacionSeleccionada: datos,
                rutafotoagenc: datos.rutaimgdetalle,
                txtprodvtadet1: datos.txtprodvtdet1,
                txtprodvtadet2: datos.txtprodvtdet2,
                txtprodvtadet3: datos.txtprodvtdet3,
                infoadicional: datos.infoadicional,
                nombreboton: 'Editar',
                idprodutra: datos.idprodutra
            });
        }
    }

    TransarDatos = (datos) => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });
        if (!Object.keys(result).length) {
            let letidprodvtadet = 0;
            var ruta = '';

            if (datos == null) {
                letidprodvtadet = 0
                ruta = '/Productos/Producto Detalles/' + this.uploader.current.getFileName();
            }
            else {
                letidprodvtadet = datos.idprodvtadet
                var capNombre = this.uploader.current.getFileName();

                if (capNombre === undefined || capNombre === null) {
                    ruta = this.state.rutafotoagenc;
                } else {
                    ruta = '/Productos/Producto Detalles/' + this.uploader.current.getFileName();
                }
            }

            const data = {
                tran: 1,
                idprodvtadet: letidprodvtadet,
                idprodutra: parseInt(this.state.idprodutra),
                txtprodvtdet1: this.state.txtprodvtadet1,
                txtprodvtdet2: this.state.txtprodvtadet2,
                txtprodvtdet3: this.state.txtprodvtadet3,
                rutaimgdetalle: ruta,
                idtipovista: 0,
                infoadicional: this.state.infoadicional === null ? '' : this.state.infoadicional,
                estado: 1,
                usucrea: sessionStorage.getItem('idusuario')
            }
            ProductosDetalles_(data).then(response => {
                try {
                    if (response.data.length > 0) {
                        if (response.data[0].message === "000000") {
                            this.cargarImagen();
                            Swal.fire({
                                icon: 'success',
                                title: datos === null ? 'Se agrego correctamente.' : 'Se actualizo correctamente.'
                            })
                            this.setState({ estadoNuevo: false });
                            this.limpiarFormulario();
                            this.cargarInformacion();
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: datos === null ? 'Error al insertar.' : 'Error al actualizar.'
                            })
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Ocurrio un error!'
                        })
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        text: 'Ocurrio un error al consumir el servicio!'
                    })
                }
            });
        }
    }

    render() {
        const { estadoNuevo, infoProductos, estadoCambio1, stateActive, stateView, stateEdit, errors } = this.state;
        return (
            <React.Fragment>
                <p className="font-weight-bold">Producto Vista Detalles</p>
                <hr />
                <div className="plus_add_agencia align-items-center d-flex" onClick={() => { this.handleNew(null) }}>
                    {estadoNuevo ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Crear Vista Detalles &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>}
                </div>
                {estadoNuevo ? (
                    <React.Fragment>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 my-2 mt-3">
                                    <label>Seleccione el Producto</label>
                                    <select name="idprodutra" className="form-control" value={this.state.idprodutra} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Selecciona...</option>
                                        {infoProductos.map((e, i) => {
                                            return [
                                                <option key={i} value={e.idprodutra}>{e.nombprodutra}</option>
                                            ]
                                        })}
                                    </select>
                                    {errors.idprodutra && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.idprodutra}</strong>}
                                </div>
                                <React.Fragment>
                                    <div className="col-md-12 my-2 text-center">
                                        <FileUploader ref={this.uploader} estado={estadoCambio1} ruta={this.state.rutafotoagenc} FCambiar={this.cambio} />
                                    </div>
                                    <div className="col-md-4 my-2">
                                        <MDBInput label="Texto 1" name="txtprodvtadet1" type="text" className="mr-5" value={this.state.txtprodvtadet1} onChange={this.textInput} />
                                        {errors.txtprodvtadet1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.txtprodvtadet1}</strong>}
                                    </div>
                                    <div className="col-md-4 my-2">
                                        <MDBInput label="Texto 2" name="txtprodvtadet2" type="text" className="mr-5" value={this.state.txtprodvtadet2} onChange={this.textInput} />
                                        {errors.txtprodvtadet2 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.txtprodvtadet2}</strong>}
                                    </div>
                                    <div className="col-md-4 my-2">
                                        <MDBInput label="Texto 3" name="txtprodvtadet3" type="text" className="mr-5" value={this.state.txtprodvtadet3} onChange={this.textInput} />
                                        {errors.txtprodvtadet3 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.txtprodvtadet3}</strong>}
                                    </div>
                                    <div className="col-md-12 my-2">
                                        <MDBInput label="Información Adicional" name="infoadicional" type="textarea" rows="5" className="mr-5" value={this.state.infoadicional} onChange={this.textInput} />
                                    </div>
                                </React.Fragment>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-primary px-5" onClick={() => this.TransarDatos(this.state.informacionSeleccionada)}>{this.state.nombreboton} Vista Detalles &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {stateEdit ?
                            (
                                <React.Fragment>
                                    <MDBDataTable
                                        striped
                                        bordered
                                        hover
                                        data={{
                                            columns: [
                                                { label: 'Producto', field: 'nombprodutra' },
                                                { label: 'Imagen Principal', field: 'imagen' },
                                                { label: 'Ruta Vista Establecida', field: 'rutaproddet' },
                                                { label: 'Texto 1', field: 'txtprodvtdet1' },
                                                { label: 'Texto 2', field: 'txtprodvtdet2' },
                                                { label: 'Texto 3', field: 'txtprodvtdet3' },
                                                { label: 'Información Adicional', field: 'infoadicional' },
                                                { label: 'Editar', field: 'editar' }
                                            ],
                                            rows: this.state.infoProductosDetalles.map((e) => {
                                                return {
                                                    nombprodutra: e.nombprodutra,
                                                    imagen: <img className="img-fluid text-center" style={{ width: '200px' }} src={`${URLImgFront}/assets${e.rutaimgdetalle}`} alt={e.rutaimgdetalle} />,
                                                    rutaproddet: e.rutaproddet,
                                                    txtprodvtdet1: e.txtprodvtdet1,
                                                    txtprodvtdet2: e.txtprodvtdet2,
                                                    txtprodvtdet3: e.txtprodvtdet3,
                                                    infoadicional: e.infoadicional,
                                                    editar: (
                                                        <React.Fragment>
                                                            <div className="text-center">
                                                                <MDBIcon onClick={() => { this.handleNew(e) }} className="text-center" icon="edit" size="2x" style={{ color: 'green', cursor: 'pointer' }} />
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                };
                                            })
                                        }}
                                    />
                                </React.Fragment>
                            ) : (<React.Fragment>
                                <div className="container">
                                    <div className="d-flex" onClick={() => { this.setState({ stateEdit: true }) }} style={{ position: 'absolute', cursor: 'pointer' }}><MDBIcon icon="times" className="text-danger pt-1" />&nbsp;<p style={{ borderBottom: '1px solid #000' }}>Cancelar</p></div>
                                    <div className="row pt-4">
                                        <div className="col-md-4 my-2 mt-3">
                                            <label>Producto Seleccionado</label>
                                            <input type="text" name="editnombprodutra" className="form-control" value={this.state.editnombprodutra} disabled />
                                        </div>
                                        <div className="col-md-4 my-2 mt-3">
                                            <label>Desea cambiar el producto - opcional</label>
                                            <select name="editidprodutra" className="form-control" defaultValue={'DEFAULT'} onChange={this.textInput}>
                                                <option value="DEFAULT" disabled>Seleccione...</option>
                                                {infoProductos.map((e, i) => {
                                                    return [
                                                        <option key={i} value={e.idprodutra}>{e.nombprodutra}</option>
                                                    ]
                                                })}
                                            </select>
                                        </div>

                                        {stateActive ? (
                                            <React.Fragment>
                                                {stateView ? (
                                                    <React.Fragment>
                                                        <div className="col-md-12 my-2 text-center">
                                                            <FileUploader ref={this.uploader} estado={estadoCambio1} ruta={this.state.editrutaimgdetalle} FCambiar={this.cambio} />
                                                        </div>
                                                        <div className="col-md-4 my-2">
                                                            <MDBInput label="Texto 1" name="edittxtprodvtdet1" type="text" className="mr-5" value={this.state.edittxtprodvtdet1} onChange={this.textInput} />
                                                        </div>
                                                        <div className="col-md-4 my-2">
                                                            <MDBInput label="Texto 2" name="edittxtprodvtdet2" type="text" className="mr-5" value={this.state.edittxtprodvtdet2} onChange={this.textInput} />
                                                        </div>
                                                        <div className="col-md-4 my-2">
                                                            <MDBInput label="Texto 3" name="edittxtprodvtdet3" type="text" className="mr-5" value={this.state.edittxtprodvtdet3} onChange={this.textInput} />
                                                        </div>
                                                        <div className="col-md-12 my-2">
                                                            <MDBInput label="Información Adicional" name="editinfoadicional" type="textarea" rows="5" className="mr-5" value={this.state.editinfoadicional} onChange={this.textInput} />
                                                        </div>
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        <div className="col-md-12 my-2 mt-3">
                                                            <MDBInput label="Escriba la URL" name="editrutaproddet" type="text" value={this.state.editrutaproddet} onChange={this.textInput} />
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                                <div className="pt-2 mt-5 modal-footer w-100">
                                                    <button type="submit" className="btn btn-success px-5" onClick={() => { this.ActualizarDatos(this.state.idSeleccionado) }}>Guardar cambios &nbsp; <MDBIcon icon="save" /></button>
                                                </div>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment></React.Fragment>
                                        )}
                                    </div>
                                </div>
                            </React.Fragment>)}
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default ProductosDetalles;